var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function transformResponseData(responseData, transform) {
    if (responseData.status === 'error') {
        return responseData;
    }
    return __assign(__assign({}, responseData), { result: transform(responseData.result) });
}
export function transformAuthResponse(response) {
    if ('pre_login_token' in response) {
        return transformTwoFactorResponse(response);
    }
    return response;
}
export function transformTwoFactorResponse(response) {
    // decode the pre_login_token to get the method
    var method;
    try {
        var twoFATokenDecoded = decodePreLoginToken(response.pre_login_token);
        method = twoFATokenDecoded['2fa_methods'][0];
    }
    catch (e) {
        console.log(e);
        method = undefined;
    }
    return {
        preLoginToken: response.pre_login_token,
        message: response.message,
        method: method,
    };
}
export function transformUserCreateResonse(response) {
    return {
        user: response.user.id,
        token: response.auth_hash,
    };
}
/**
 * Returns the decoded JWT token used for 2FA
 */
function decodePreLoginToken(preLoginToken) {
    return JSON.parse(atob(preLoginToken.split('.')[1]));
}
